var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"xtglwxpart"}},[_c('div',{staticClass:"sjmydesh"},[_c('img',{attrs:{"src":require("../../assets/zzkfz.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("正在开发中......敬请期待~")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2edf7960","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xtglwxpart/xtglwxpart.vue
// module id = null
// module chunks = 